import React from 'react'
import Img from 'gatsby-image'
import './logo-grid.scss'

class LogoGrid extends React.Component {

  render() {
    const content = this.props.content

    if (content) {
      const gridType = content.gridType ? content.gridType : 'primary'
      const logos = content.logo ? content.logo : []
      const backgroundColor = content.gridBackgroundColor ? content.gridBackgroundColor : null
      const style = {objectFit: 'contain'}
      
      return (
        <div className="logo-grid-container" style={{backgroundColor}}>
          {logos.map((logo, i) => {
            return (
              <div key={i} className={`grid-logo-wrapper ${gridType}`}>
                <Img className="grid-logo" sizes={logo.sizes} imgStyle={style}/>
              </div>
            )
          })}
        </div>
      )
    } else {
      return null
    }
  }
}

export default LogoGrid


// WEBPACK FOOTER //
// ./src/components/LogoGrid/logo-grid.js